// The class name of the aptrinsic knowledge center bot widget that
// is created and destoyed whenever the corresponding UI element is clicked.
export const APTRINSIC_WIDGET_SELECTOR = '.apt-widget-container';

// This is the data-name attribute of the bot target. It must match the
// CSS Selector set in the knowledge center bot.
export const BOT_DATA_NAME = 'navigation-control-give-feedback-link';

// The delay between each click in the double click.
export const CLICK_DELAY = 50;
